<div class="tablero-container">
    <img src="/img/small-logo.png" alt="Logo del sistema" />
    <h2>{{ appTitle }}</h2>
    <button (click)="logout()" class="secondary-button">Cerrar sesión</button>
</div>
